import {
  PEN_MINUS_CURSOR,
  PEN_PLUS_CURSOR,
  PEN_TOOL_CURSOR,
} from '@/components/app/editor/tools/pen-cursor-urls'
import type { PenHoverTarget } from '../types/node-edit-targets'

/** Pen-edit cursor for the hover target: pen− over an anchor (remove), the plain pen over an
 *  endpoint (continue), pen+ everywhere else (add on a segment). */
export function resolvePenEditCursor(penHover: PenHoverTarget): string {
  if (penHover?.kind === 'anchor') return PEN_MINUS_CURSOR
  if (penHover?.kind === 'endpoint') return PEN_TOOL_CURSOR

  return PEN_PLUS_CURSOR
}
